var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBucketMarked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6284 22.6641L15.7534 24.7891L20.3576 20.5391",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.481 2.83203L7.35266 7.97453",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.5193 2.83203L26.6477 7.97453",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.8335 11.1204C2.8335 8.49961 4.236 8.28711 5.9785 8.28711H28.0218C29.7643 8.28711 31.1668 8.49961 31.1668 11.1204C31.1668 14.1663 29.7643 13.9538 28.0218 13.9538H5.9785C4.236 13.9538 2.8335 14.1663 2.8335 11.1204Z",
    stroke: "#735BF2",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.9585 14.1641L6.956 26.4041C7.40933 29.1524 8.50016 31.1641 12.5518 31.1641H21.0943C25.5002 31.1641 26.1518 29.2374 26.6618 26.5741L29.0418 14.1641",
    stroke: "#735BF2",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBucketMarked);
export default __webpack_public_path__ + "static/media/iconBucketMarked.8a5ea89cef66896bf4e7189b211bd969.svg";
export { ForwardRef as ReactComponent };